const entities = require('entities');
export default (type = '') => ({
  name: 'PeopleDirectory',
  // * data()
  people: [],
  colors: [],
  ready: false,
  nameSearch: '',
  expanded: false,
  selectedClinicalTopics: [],
  selectedLeadershipTopics: [],
  selectedEducationTopics: [],
  clinicalTopics: '',
  leadershipTopics: '',
  educationTopics: '',
  selectedLeadershipGroup: '',
  desktop: window.innerWidth >= 992 ? true : false,
  leadershipGroup: '',
  peopleLeadershipGroup: [],
  filteredPeople: [],
  alphabetizePeople: [],
  type: type,
  baseEndpoint: `${window.location.origin}/api/v1/`,
  async init() {
    this.expanded = !this.desktop && (this.type === 'Leadership' || this.type === 'Speaker') ? false : true;
    const res = await fetch(this.baseEndpoint + `people?type=${this.type}`);
    this.people = await res.json(); 

    // alphabetize people by last name
    this.people = this.people.sort((a, b) => {
      const nameA = a.lastName.toUpperCase();
      const nameB = b.lastName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    if (this.type === 'Recruiter') {
      this.people = this.people.sort((a, b) => {
        return b.order - a.order;
      });
    }

    this.filteredPeople = this.people;
    
    this.leadershipGroup = await this.makeSelectFieldEndpoint('leadershipGroup');
    this.clinicalTopics = this.makeSelectField('clinicalTopics');
    this.leadershipTopics = this.makeSelectField('leadershipTopics');
    this.educationTopics = this.makeSelectField('educationTopics');
    this.peopleLeadershipGroup = this.makeLeadershipGroup(this.leadershipGroup);


    let noDefaultFiltersSelected = 0;
    const urlParams = new URLSearchParams(window.location.search);
    const paramClinicalTopics = urlParams.get('clinical_topics') ? urlParams.get('clinical_topics').split(',') : []; 

    if (paramClinicalTopics) {
      this.selectedClinicalTopics = paramClinicalTopics;
      noDefaultFiltersSelected = 1;
    }


    
    if (noDefaultFiltersSelected == 1) {
      this.filterPeople()
    }

    this.ready = true;

    

  },

  searchByName() {
    this.selectedLeadershipGroup = 'any';
    this.selectedClinicalTopics = [];
    this.selectedLeadershipTopics = [];
    this.selectedEducationTopics = [];
    // filter people by firstName and lastName if contains any of nameSearch
    this.filteredPeople = this.people.filter((person) => {
      const firstName = person.firstName.toLowerCase();
      const lastName = person.lastName.toLowerCase();
      return firstName.includes(this.nameSearch.toLowerCase()) || lastName.includes(this.nameSearch.toLowerCase());
    });
    if (type === 'Leadership') {
      this.peopleLeadershipGroup = this.makeLeadershipGroup(this.leadershipGroup);
    }
  },
  makeSelectField(filterBy) {
    const items = this.filteredPeople.map((people) => {
      people[filterBy] = entities.decodeHTML(people[filterBy]); // decode entities coming from the name of taxonomy
      // split around a comma only if there are no double quotes or if there is an even number of double quotes ahead of it.
      return people[filterBy].split(/, (?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/);
    });
    const uniqueItems = [...new Set(items.flat())].filter((item) => item !== '');
    const sortedItems = uniqueItems.sort().map((item) => item.replaceAll('"', ''));
    //console.log(sortedItems);
    return sortedItems;
  },
  async makeSelectFieldEndpoint(filterBy) {
    const res = await fetch(`${this.baseEndpoint}tax/${filterBy}`);
    const taxList = await res.json();
    // const taxListNames = taxList.map((item) => item.name);
    return taxList; 
  },
  makeLeadershipGroup(groups) {
    let allGroups = [];
    groups.forEach((group) => {
      let groupArray = {};
      groupArray.name = group.name;
      groupArray.tid = group.tid;
      const filteredPeople = this.filteredPeople.filter((person) => {
        let ids = person.leadershipGroup.split(', ');
        return ids.includes(group.tid);
      });
      groupArray.people = filteredPeople;
      allGroups.push(groupArray);
    });

    return allGroups;
  },
  anyTopic(value) {
    this[value] = [];
    this.filterPeople();
  },
  filterByTopic(value) {
    this.selectedClinicalTopics = [value];
    this.filterPeople();
  },
  sortPeople(group) {
    if (group.name.includes('Regional Leadership')) {
      const first = group.people.filter((person) => {
        return person.jobTitle === 'President';
      });
      const second = group.people.filter((person) => {
        return person.jobTitle.includes('Regional Vice President');
      });
      const third = group.people.filter((person) => {
        return person.jobTitle.includes('Director of APPs');
      });
      const rest = group.people.filter((person) => {
        return !person.jobTitle.includes('Regional Vice President') || !person.jobTitle.includes('Director of APPs');
      });
      group.people = [...first, ...second, ...third, ...rest];
    } else if (group.name.includes('Executive Leadership Team')) {
      const first = group.people.filter((person) => {
        return person.jobTitle.includes('Chief Executive Officer');
      });
      const rest = group.people.filter((person) => {
        return !person.jobTitle.includes('Chief Executive Officer');
      });
      group.people = [...first, ...rest];
    } else if (group.name.includes('Board Members')) {
      const first = group.people.filter((person) => {
        return person.jobTitle.includes('Executive Chairman');
      });
      const rest = group.people.filter((person) => {
        return !person.jobTitle.includes('Executive Chairman');
      });
      group.people = [...first, ...rest];
    } else if (group.tid === '15') {
      group.people = group.people.sort((a, b) => {
        return b.nbgcOrder - a.nbgcOrder;
      });
    }

    group.people = [...new Set(group.people)];

    return group.people;
  },
  filterPeople() {
    this.nameSearch = '';
    const filteredPeople = this.people.filter((person) => {
      if (
        this.selectedClinicalTopics.every((topic) => person.clinicalTopics.includes(topic)) &&
        this.selectedLeadershipTopics.every((topic) => person.leadershipTopics.includes(topic)) &&
        this.selectedEducationTopics.every((topic) => person.educationTopics.includes(topic))
      ) {
        return true;
      }
      return false;
    });
    this.filteredPeople = filteredPeople;

    let clinicalTopics = Array.isArray(this.selectedClinicalTopics) && this.selectedClinicalTopics.length > 0 ? this.selectedClinicalTopics : [];
    this.setUrlParams(clinicalTopics);

  },
  setUrlParams(clinicalTopics = null) {


    const url = new URL(window.location.href);

    if (clinicalTopics && clinicalTopics.length > 0) {
      url.searchParams.set('clinical_topics', clinicalTopics);
    } else {
      url.searchParams.delete('clinical_topics');
    }
    
    window.history.pushState({ path: url.href }, '', url.href);
  },
  filterGroup() {
    this.nameSearch = '';
  },
});
